import {
  ConversationTypeEnum,
  ReplyOption
} from "@coxauto-ui/cxm/communications/interfaces";
import { useContext } from "react";
import styled from "styled-components";
import { ConversationContext, ConversationDetailsContext } from "../../context";
import MessageSendButton from "../message-send-button";
import { MessageInput } from "../message-input";
import { MessageCallInfo } from "../message-call-info";
import { StationeryOptions } from "@coxauto-ui/cxm/communications/api";
import { ReplyAlertsBottomContainer } from "../reply-alerts-bottom-container";

interface PhoneReplyProps {
  stationeryOptions: StationeryOptions;
  selectedReplyOption: ReplyOption | null;
  messageFailedToSend: boolean;
  messageSentResponseFailedMsg: string;
  onMessageSendFailed: () => void;
  onMessageSendFailedSetMsg: (msg: string) => void;
}

const StyledReplySubjectBottom = styled.div`
  margin-top: 0.5em;
  margin-bottom: 0.5em;
`;

const StyledReplyBottom = styled.div`
  display: flex;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export function PhoneReply({
  stationeryOptions,
  selectedReplyOption,
  messageFailedToSend,
  messageSentResponseFailedMsg,
  onMessageSendFailed,
  onMessageSendFailedSetMsg
}: PhoneReplyProps) {
  const { autoLeadId, repairOrderId, autoLeadStatus, leadStatusError } =
    useContext(ConversationContext);
  const { emojiPickerError } = useContext(ConversationDetailsContext);

  return (
    <>
      <StyledReplySubjectBottom>
        <MessageCallInfo />
      </StyledReplySubjectBottom>
      <StyledReplyBottom>
        <MessageInput
          isDisabled={!selectedReplyOption || messageFailedToSend}
          stationeryOptions={stationeryOptions}
        />
      </StyledReplyBottom>
      <div>
        <ReplyAlertsBottomContainer
          autoLeadId={autoLeadId}
          autoLeadStatus={autoLeadStatus}
          conversationType={ConversationTypeEnum.PHONE}
          emojiPickerError={emojiPickerError}
          leadStatusError={leadStatusError}
          messageFailedToSend={messageFailedToSend}
          messageSentResponseFailedMsg={messageSentResponseFailedMsg}
          repairOrderId={repairOrderId}
          selectedReplyOption={selectedReplyOption}
        />
        <StyledButtonContainer>
          <div style={{ marginLeft: "auto", display: "flex", gap: "0" }}>
            <MessageSendButton
              isTextAndNoPhoneNumber={false}
              isTextWithRepairOrderOnly={false}
              onMessageSendFailed={onMessageSendFailed}
              onMessageSendFailedSetMsg={onMessageSendFailedSetMsg}
            />
          </div>
        </StyledButtonContainer>
      </div>
    </>
  );
}

export default PhoneReply;
